import React, { Suspense } from 'react'
import { Navigate } from 'react-router-dom'
import { Route as RouteType } from 'commons/types/route'
import { REDIRECT_AFTER_AUTH } from 'commons/constants/store'
import { LOGIN_ROUTE } from 'commons/constants/app'
import { UserContextType } from 'commons/contexts/UserContext/context'
import Fallback from 'pages/Common/Fallback'
import Forbidden from 'pages/Common/Forbidden'
import Layout from './Layout'

type Props = { loggedIn: boolean } & RouteType & Pick<UserContextType, 'hasPermission'>

const AppRoute = ({
  path,
  isPublic,
  loggedIn,
  hasLayout = true,
  hasPermission,
  permissions: routePermissions,
  component: Component = 'div',
}: Props) => {
  if (!isPublic && !loggedIn) {
    localStorage.setItem(REDIRECT_AFTER_AUTH, path)
    return <Navigate to={LOGIN_ROUTE} />
  }

  if (routePermissions && !hasPermission(routePermissions)) {
    return (
      <Layout visible={hasLayout}>
        <Forbidden />
      </Layout>
    )
  }

  return (
    <Layout visible={hasLayout}>
      <Suspense fallback={<Fallback />}>
        <Component />
      </Suspense>
    </Layout>
  )
}
export default AppRoute
